import { observer } from "mobx-react-lite";
import React, { memo, useEffect, useRef, useState } from "react";
import imgKeyActive from "../../img/icons/icon-key-2.png";
import imgKeyDeactive from "../../img/icons/icon-key-2-deact.png";
import Media from "../../api/Media";
import ApiData from "../../api/ApiData";
import RolesState from "../../api/RolesState";
import User from "../../api/User";

const pad2 = (n) => String(n).padStart(2, "0");

/** ISO / API → «дд.мм.гг» и «чч:мм» (локальное время) */
const formatLastSessionDisplay = (value) => {
  if (value === null || value === undefined || value === "") {
    return { date: "—", time: "" };
  }
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) {
    return { date: String(value), time: "" };
  }
  const day = pad2(d.getDate());
  const month = pad2(d.getMonth() + 1);
  const year = String(d.getFullYear()).slice(-2);
  const hours = pad2(d.getHours());
  const minutes = pad2(d.getMinutes());
  return {
    date: `${day}.${month}.${year}`,
    time: `${hours}:${minutes}`,
  };
};

const getV4LicenseBadge = (itemsoft) => {
  if (itemsoft.activated === "hold") {
    return { label: "Приостановлена", variant: "frozen" };
  }

  const hasLicense =
    itemsoft.activ_data !== "" &&
    itemsoft.activ_data !== null &&
    itemsoft.id_license;

  if (!hasLicense && itemsoft.valid_period_days !== "Обновите") {
    return { label: "Без лицензии", variant: "muted" };
  }

  const days = itemsoft.valid_period_days;
  if (days === "Бессрочная" || days === "Бессрочно") {
    return { label: "Бессрочная", variant: "success" };
  }
  if (days === "Истекла") {
    return { label: "Истекла", variant: "danger" };
  }
  if (days === "Обновите") {
    return { label: "Обновите", variant: "warning" };
  }
  if (days !== "" && days !== null && days !== undefined) {
    return { label: String(days), variant: "success" };
  }
  return { label: "Без лицензии", variant: "muted" };
};

const ItemSoftCompany = observer((props) => {
  const [subAction, setSubAction] = useState(false);
  const [actionsMenuOpen, setActionsMenuOpen] = useState(false);
  const actionsMenuRef = useRef(null);
  const itemsoft = props.itemsoft;

  useEffect(() => {
    if (!actionsMenuOpen) return;
    const onDocPointer = (e) => {
      if (
        actionsMenuRef.current &&
        !actionsMenuRef.current.contains(e.target)
      ) {
        setActionsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocPointer);
    document.addEventListener("touchstart", onDocPointer);
    return () => {
      document.removeEventListener("mousedown", onDocPointer);
      document.removeEventListener("touchstart", onDocPointer);
    };
  }, [actionsMenuOpen]);

  const runAction = (fn) => {
    fn();
    setActionsMenuOpen(false);
    setSubAction(false);
  };

  const checkLicensing = () => {
    ApiData.checkLic(itemsoft.id_license);
  };

  const disableLicense = async () => {
    ApiData.setActiveLicenseAndDisable(itemsoft.id_license, false);
  };
  const enabledLicense = async () => {
    ApiData.setActiveLicenseAndDisable(itemsoft.id_license, true);
  };

  const rowBaseClass =
    itemsoft.activated === "hold"
      ? "lic_container_item_hold"
      : itemsoft.type_software === "old" ||
          (itemsoft.valid_period_days === "Истекла" &&
            itemsoft.activated !== "hold")
        ? "lic_container_item_old"
        : "lic_container_item";

  const licensedWithMenu =
    (itemsoft.activated || itemsoft.activated === "hold") &&
    (RolesState.licen_prol_id ||
      RolesState.unlink_licensing ||
      RolesState.check_licensing ||
      User.user?.is_superuser);

  const showV4ActionColumn =
    RolesState.unlink_licensing ||
    RolesState.attach_licensing ||
    RolesState.licen_prol_id ||
    RolesState.check_licensing ||
    User.user?.is_superuser;

  const renderV4DropdownItems = () => {
    const items = [];

    if (licensedWithMenu) {
      if (RolesState.check_licensing || User.user?.is_superuser) {
        items.push(
          <button
            key="check"
            type="button"
            className="cc-v4-soft-dropdown-item"
            onClick={() => runAction(checkLicensing)}
          >
            Проверить лицензию
          </button>,
        );
      }
      if (RolesState.post_generate || User.user?.is_superuser) {
        items.push(
          <button
            key="renew"
            type="button"
            className="cc-v4-soft-dropdown-item"
            onClick={() =>
              runAction(() => props.actionClientLicRenewal(itemsoft))
            }
          >
            Продлить лицензию
          </button>,
        );
      }
      if (
        (User.user?.is_superuser && itemsoft.activated !== "hold") ||
        (RolesState.patch_unlink && itemsoft.activated !== "hold")
      ) {
        items.push(
          <button
            key="freeze"
            type="button"
            className="cc-v4-soft-dropdown-item"
            onClick={() => runAction(disableLicense)}
          >
            Заморозить лицензию
          </button>,
        );
      }
      if (
        (User.user?.is_superuser && itemsoft.activated === "hold") ||
        (RolesState.patch_unlink && itemsoft.activated === "hold")
      ) {
        items.push(
          <button
            key="unfreeze"
            type="button"
            className="cc-v4-soft-dropdown-item"
            onClick={() => runAction(enabledLicense)}
          >
            Разблокировать лицензию
          </button>,
        );
      }
      if (RolesState.patch_unlink || User.user?.is_superuser) {
        items.push(
          <button
            key="unlink"
            type="button"
            className="cc-v4-soft-dropdown-item cc-v4-soft-dropdown-item--danger"
            onClick={() =>
              runAction(() => props.actionClientLicRemove(itemsoft))
            }
          >
            Отвязать лицензию
          </button>,
        );
      }
    } else {
      if (RolesState.attach_licensing || User.user?.is_superuser) {
        items.push(
          <button
            key="attach"
            type="button"
            className="cc-v4-soft-dropdown-item"
            onClick={() => runAction(() => props.actionClientLicSet(itemsoft))}
          >
            Привязать лицензию к этому клиенту
          </button>,
        );
      }
    }

    return items;
  };

  const renderV4ActionCell = () => {
    const badge = getV4LicenseBadge(itemsoft);
    const menuItems = renderV4DropdownItems();

    return (
      <span className="soft_list_valid_action tabs_lgt_grey_border padding_7_5 cc-v4-soft-action-cell-wrap">
        <span className="cc-v4-soft-action-cell action-cell">
          <span className={`cc-v4-lic-badge cc-v4-lic-badge--${badge.variant}`}>
            {badge.label}
          </span>
          {menuItems.length > 0 ? (
            <div
              ref={actionsMenuRef}
              className={`dropdown-wrapper cc-v4-soft-dropdown${
                actionsMenuOpen ? " is-open" : ""
              }`}
              onMouseEnter={() => setActionsMenuOpen(true)}
              onMouseLeave={() => setActionsMenuOpen(false)}
            >
              <button
                type="button"
                className="btn-outline-v4 cc-v4-soft-actions-btn"
                aria-expanded={actionsMenuOpen}
                onClick={(e) => {
                  e.preventDefault();
                  setActionsMenuOpen((open) => !open);
                }}
              >
                Действия
              </button>
              <div
                className="dropdown-menu cc-v4-soft-dropdown-menu"
                role="menu"
              >
                {menuItems}
              </div>
            </div>
          ) : null}
        </span>
      </span>
    );
  };

  const renderLegacyActionCell = () => {
    if (licensedWithMenu) {
      return (
        <label
          onClick={() => (subAction ? setSubAction(false) : setSubAction(true))}
          className="visible-container-soft-key soft_list_valid_action tabs_lgt_grey_border"
          style={{ justifyContent: !Media.mobile ? "flex-start" : "center" }}
        >
          <img className="key-btn" src={imgKeyDeactive} alt="" />
          <span className="visible-text-soft-key">
            Действия с привязанной лицензией
          </span>
          {!Media.mobile ? <span>{itemsoft.valid_period_days}</span> : null}
          {subAction ? (
            <div className="sub_action_client_container_border">
              <ul className="sub_action_client_container">
                <li
                  className="sub_action_client_closed"
                  onClick={() => setSubAction(false)}
                >
                  Х
                </li>
                {RolesState.check_licensing || User.user?.is_superuser ? (
                  <li onClick={() => runAction(checkLicensing)}>
                    Проверить лицензию
                  </li>
                ) : null}
                {RolesState.post_generate || User.user?.is_superuser ? (
                  <li
                    onClick={() =>
                      runAction(() => props.actionClientLicRenewal(itemsoft))
                    }
                  >
                    Продлить лицензию
                  </li>
                ) : null}
                {(User.user?.is_superuser && itemsoft.activated !== "hold") ||
                (RolesState.patch_unlink && itemsoft.activated !== "hold") ? (
                  <li onClick={() => runAction(disableLicense)}>
                    Заморозить лицензию
                  </li>
                ) : null}
                {(User.user?.is_superuser && itemsoft.activated === "hold") ||
                (RolesState.patch_unlink && itemsoft.activated === "hold") ? (
                  <li onClick={() => runAction(enabledLicense)}>
                    Разблокировать лицензию
                  </li>
                ) : null}
                {RolesState.patch_unlink || User.user?.is_superuser ? (
                  <li
                    onClick={() =>
                      runAction(() => props.actionClientLicRemove(itemsoft))
                    }
                  >
                    Отвязать лицензию
                  </li>
                ) : null}
              </ul>
            </div>
          ) : null}
        </label>
      );
    }

    if (RolesState.check_licensing || User.user?.is_superuser) {
      return (
        <label
          onClick={() => props.actionClientLicSet(itemsoft)}
          className="visible-container-soft-key soft_list_valid_action tabs_lgt_grey_border"
        >
          <img className="key-btn" src={imgKeyActive} alt="" />
          <ul>
            <li className="visible-text-soft-key">
              Привязать лицензию к этому клиенту
            </li>
            <li></li>
          </ul>
        </label>
      );
    }

    return null;
  };

  if (
    !(
      itemsoft.software_client_rel !== null ||
      itemsoft.valid_period_days === "Обновите"
    )
  ) {
    return null;
  }

  const rel = itemsoft.software_client_rel;
  const lastSession = formatLastSessionDisplay(itemsoft.last_session);

  return (
    <div
      className={props.rowClass ? props.rowClass(rowBaseClass) : rowBaseClass}
    >
      <span className="soft_list_name tabs_lgt_grey_border padding_7_5">
        {Media.mobile ? rel?.name?.slice(0, 9) : rel?.name}
      </span>
      <span className="soft_list_client_id tabs_lgt_grey_border padding_7_5">
        {Media.mobile
          ? "..." + itemsoft.client_id.substr(-6, 6)
          : itemsoft.client_id}
      </span>
      {Media.mobile ? null : (
        <span className="soft_list_last_session tabs_lgt_grey_border padding_7_5">
          {props.v4Layout ? (
            <>
              <span className="cc-v4-session-date">{lastSession.date}</span>
              {lastSession.time ? (
                <span className="cc-v4-session-time">{lastSession.time}</span>
              ) : null}
            </>
          ) : lastSession.time ? (
            `${lastSession.date} ${lastSession.time}`
          ) : (
            lastSession.date
          )}
        </span>
      )}
      <span className="soft_list_software_version tabs_lgt_grey_border padding_7_5">
        {Media.mobile
          ? itemsoft.software_version.slice(0, 8)
          : itemsoft.software_version}
      </span>
      {props.v4Layout && showV4ActionColumn
        ? renderV4ActionCell()
        : !props.v4Layout
          ? renderLegacyActionCell()
          : null}
    </div>
  );
});

export default memo(ItemSoftCompany);
